import textEllipsis from './text-ellipsis'

export { textEllipsis }
